const checkAccess = (role, allowedRoles = [2, 3, 4]) => {
  return allowedRoles.includes(role)
}

export default checkAccess
